/**
 * @generated SignedSource<<1b2123c9f8a535c59dcf412261a46847>>
 * @relayHash 7bdb421d7a66da325f8a03b9ac61513a
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 7bdb421d7a66da325f8a03b9ac61513a

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "originContractId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "originContractId",
        "variableName": "originContractId"
      }
    ],
    "concreteType": "PropositionResponse",
    "kind": "LinkedField",
    "name": "duplicateContract",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "propositionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DuplicateContractMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DuplicateContractMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7bdb421d7a66da325f8a03b9ac61513a",
    "metadata": {},
    "name": "DuplicateContractMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "e041a1be9492c457e7deb0b7da37bc22";

export default node;
